import { IOrderPackingList } from '@/interfaces/order';
import { formatNumber } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  items?: Partial<IOrderPackingList>[];
}

const TemplateOrderPackingList = ({ items }: IProps) => {
  return (
    <>
      <div className="flex w-full text-xs mt-2">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={5}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
          }}
        >
          <tr>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={5}
            >
              <strong>
                ลำดับ <br /> Line No.
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={140}
            >
              <strong>
                เลขที่พาเลท <br /> Pallet No.
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>
                รหัสสินค้า <br /> Item Code
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                รายการสินค้า <br /> Item Description
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                เลขที่ผลิต <br /> Lot no.
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                จำนวน <br /> Quantity
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                หน่วย <br />
                Unit
              </strong>
            </td>
          </tr>
          {items?.map((i, idx) => {
            return (
              <tr key={idx}>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {idx + 1}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.transportTrackingNo}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                  }}
                >
                  {i.itemNo}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                  }}
                >
                  {i.itemDescription}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                  }}
                >
                  {i.lotNo}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {formatNumber(Number(i.quantity), 2)}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.unitOfMeasure}
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </>
  );
};

export default TemplateOrderPackingList;
